import {Flex,Grid,GridItem,Box,Select,InputGroup,Button,
  InputLeftElement,Input,Heading,Text,TableContainer,
  Checkbox,Table,Thead,Tbody,Th,Textarea,Tr,Td,} from '@chakra-ui/react';
  import styled from "@emotion/styled";
  import { LuSearch as SearchIcon } from "react-icons/lu";
  import { useState,useEffect } from 'react';
  import {useAtom,atom} from 'jotai'
  import { useMutation, useQuery, useQueryClient } from 'react-query';
  import apiCall from '../../../../utils/apiCall';
  import {  openAtom, notificationAtom, openNAtom, modalAtom } from "../../../../context";
import { Loader } from '../../../../customs';
import { TbReload as ReloadIcon } from "react-icons/tb";
import ReactPaginate from 'react-paginate';
import { format } from "date-fns";

const indexAtom = atom<number | null>(null);

  const HeadStyle={
    borderBottom:"1px solid var(--dark-green-color)",
    padding:'15px 5px',
  }
  const DataStyle = {
    padding:'5px 5px',
    thcolor:'var(--dark-green-color)'
  }
  
  
  const ROWSTYLE = styled.tr`
    & > td:last-of-type{
      width:50px;
      height:63px;
      & > div{
        display:none;
      }
    }
    &:hover > *{
      cursor: pointer;
      background-color:var(--table-highlight);
    } 
    & > td{
      width:140px;
    }
  `

export default function BatchPublish() {
  const [hide,set_hide] = useState<boolean>(true);
  const [activeIndex] = useAtom(indexAtom);
  const [,set_open] = useAtom(openAtom);
  const [,set_n_open] = useAtom(openNAtom);
  const [,set_notification] = useAtom(notificationAtom);
  const queryClient = useQueryClient();
 const [Reason,set_reason] = useState('');
  const [,set_modal] = useAtom(modalAtom);
  const [is_check_all,set_is_check_all] = useState<any>(false);
  const [checked_ids,set_checked_ids] = useState<any>([]);

  const [selected_period,set_selected_period] = useState<null | string>(null);
  const [selected_subject,set_selected_subject] = useState<null | string>(null);
  let  {data,isLoading:l}:{data:any;isLoading:boolean} = useQuery<any>([''],{
    queryFn: async ()=> await Promise.allSettled([apiCall().get('/exam/setup/examPeriod'),apiCall().get('/exam/setup/examSubject')
    ]),
  
    select(data:any){
      //console.log(data,'data')
      return data
    }
  })
  let  {data:data1,isLoading}:{data:any;isLoading:boolean} = useQuery<any>([selected_period],{
    queryFn: async ()=> await apiCall().get(`/Exam/reviewedNotPublishedSubjects?examPeriodId=${selected_period}`),
    retry:0,
    enabled:Boolean(selected_period),
    select(data:any){
      //console.log(data,'data')
      return data.data.Data;
    }
  })


  const all_periods:any = !data?[]:data[0]?.value?.data.Data;
const all_subjects:any = !data?.length?[]:data[1]?.value?.data.Data;
const all_request:any = data1 && data1.length > 0 ? data1?.map((e:any) => ({...e,Id:Math.floor(Math.random() * 1000 +1)})) : [];

  const [search,set_search] = useState('');

  const handleSearch = (e:any)=>{
    let val = e.target.value;
    set_search(val);
    if(val){
      let new_data = filter_data?.filter((eData:any) => Object.values(eData).join('').toLowerCase().includes(val.toLowerCase()) );
      if(new_data.length > 0)set_filter_data(new_data)
      else set_filter_data(all_request)
    }
    else set_filter_data(all_request)
  }
  
  const [filter_data,set_filter_data] = useState<any>(all_request);

  const itemsPerPage = 10;
  const [itemOffset, setItemOffset] = useState(0);
  const endOffset = itemOffset + itemsPerPage;
  console.log(`Loading items from ${itemOffset} to ${endOffset}`);
  const currentItems = filter_data?.slice(itemOffset, endOffset);
  const pageCount = Math.ceil(filter_data?.length / itemsPerPage);

  const handlePageClick = (event:any) => {
    const newOffset = (event.selected * itemsPerPage) % filter_data?.length;
    console.log(
      `User requested page number ${event.selected}, which is offset ${newOffset}`
    );
    setItemOffset(newOffset);
  };


  const { isLoading: publishIsLoading, mutate: handleBatchPublish } = useMutation({
    mutationKey: ['publish-request'],
    mutationFn: async () => {
      // Filter the selected data based on checked IDs and ensure ExamPeriodId and ExamSubjectId exist
      let tempData = filter_data.filter((eData: any) => {
        let check = checked_ids.find((e: any) => e == eData.Id);
        return check && eData?.ExamPeriodId && eData?.ExamSubjectId; // Only include if IDs are valid
      });
  
     // console.log("Filtered Data for API:", tempData);
        if (tempData.length === 0) {
        throw new Error("No valid data selected for publishing.");
      }
  
      // Post request to publish the results
      return await apiCall().post(`/Exam/examResultPublish`, tempData.map((e: any) => ({
        ExamPeriodId: e?.ExamPeriodId,
        ExamSubjectId: e?.ExamSubjectId
      })));
    },
    onSuccess(data: any) {
      //console.log("API Response:", data);
  
      set_notification({
        type: 'success',
        message: data?.data?.Message || 'Results Published Successfully',
      });
      set_n_open(true);
  
      // Invalidate queries to refresh data
      queryClient.invalidateQueries(['all-publish-request']);
    },
    onError(error: any) {
      console.error("API Error:", error);
      
      // If the error is from the server, log the response and status
      console.error("Error Status:", error?.response?.status);
      console.error("Error Data:", error?.response?.data);
  
      set_notification({
        type: 'error',
        message: error?.response?.data?.Message || 'An error occurred while publishing results.',
      });
      set_n_open(true);
    },
    onSettled() {
      set_open(false);
    },
  });
  
  

  const handleMultipleCheck=()=>{
    if(!is_check_all){
      let allStudents = filter_data && filter_data.length > 0 ? 
        filter_data.map((eStudent:any)=>eStudent.Id):[];
      set_checked_ids(allStudents);
    }else{
      set_checked_ids([]);
    }
    set_is_check_all(!is_check_all);
  }

  const handleSingleCheck=(StudentNo:string) =>{
    let check = checked_ids.find((eStudent:string) => eStudent === StudentNo);
    if(check){
      set_checked_ids((all_students:any) => all_students.filter((eStudent:string) => eStudent !== StudentNo))
    }else{
      set_checked_ids([...checked_ids,StudentNo])
    }

  }
  const handleCheck=(StudentNo:string)=>{
    let check = checked_ids.find((eStudent:string) => eStudent === StudentNo);
    return check?true:false;
  }
  useEffect(()=>{
    if(selected_period){
      let data = all_request.filter((eData:any) => eData.ExamPeriodId == selected_period);
     
      set_filter_data(data);
      
    }
    else{
      set_filter_data(all_request);
    }
  },[selected_period])
  useEffect(()=>{
    if(selected_subject){
      let data = all_request.filter((eData:any) => eData.ExamSubjectId == selected_subject);
 
      set_filter_data(data);
      
      
    }
    else{
      set_filter_data(all_request);
    }
  },[selected_subject])

  useEffect(()=>{
   //console.log(all_request)
   set_filter_data(data1?data1?.map((e:any) => ({...e,Id:Math.floor(Math.random() * 1000 +1)})) : [])
    //console.log(selected_period,'period')
   
  },[selected_period,data1])

  return (
    <>
    {isLoading?<Loader />:
    <Grid minW="80dvw" p="20px" templateColumns="1fr">
      <GridItem as={Flex} gap="20px" align="center">
        {/* <InputGroup h="40px" width="250px" bg="var(--white-color)" borderColor="var(--dark-green-color)">
          <InputLeftElement pointerEvents='none'>
            <SearchIcon color='gray.300' />
          </InputLeftElement>
          <Input value={search} onChange={handleSearch} type='text' placeholder='search' />
            <span style={{position:'absolute',zIndex:'1',
            right:'10px',cursor:'pointer',top:'12px'}}><ReloadIcon /></span>
        </InputGroup> */}
        <Select placeholder="Exam Period" width="150px" bg="var(--white-color)" 
          borderColor="var(dark-green-color)" onChange={(e:any)=>set_selected_period(e.target.value)}>
            {all_periods?.length > 0 ? all_periods.map((e:any) =><option key={e?.Id} value={e?.Id}>{e?.ExamName}</option>):<></>}
        </Select>
        <Select placeholder="Exam Subject" width="150px" bg="var(--white-color)" 
          borderColor="var(dark-green-color)" onChange={(e:any)=>set_selected_subject(e.target.value)}>
            {all_subjects?.length > 0 ? all_subjects.map((e:any) =><option key={e?.Id} value={e?.Id}>{e?.Name}</option>):<></>}
        </Select>
      </GridItem>
      <GridItem as={Flex} flexDir="column" gap="20px">
        <Heading>All Pending Publish Subjects Results</Heading>
        <Text>Showing {itemOffset} - {itemOffset + itemsPerPage > filter_data?.length?filter_data?.length:endOffset} of {filter_data?.length}</Text>
        {  filter_data && filter_data.length > 0 ? <TableContainer mt="20px">
          <Table size='sm'>
            <Thead>
              <Tr >
                <Th sx={{...HeadStyle,maxWidth:"50px"}}>
                  <label>
                    <Checkbox colorScheme={is_check_all?'green':'none'} isChecked={is_check_all} onChange={handleMultipleCheck} />
                  </label>
                </Th>
                <Th sx={HeadStyle}>Exam Period</Th>
                <Th sx={HeadStyle}>Exam Subject</Th>
                {/* <Th sx={HeadStyle}>Date Reviewed</Th>
                <Th sx={HeadStyle}>Date Reviewed</Th> */}
              </Tr>
            </Thead>
            <Tbody>
            {currentItems.map((eCandidate:any,index:number) =><ROWSTYLE key={eCandidate.Id}>
                <Td sx={{...DataStyle,maxWidth:"50px"}}>
                  <label>
                  <Checkbox colorScheme={handleCheck(eCandidate.Id)?'green':'none'} isChecked={handleCheck(eCandidate.Id)} onChange={()=>handleSingleCheck(eCandidate.Id)} />
                  </label>
                </Td>
                <Td sx={DataStyle}>{eCandidate?.ExamPeriod}</Td>
                <Td sx={DataStyle}>{eCandidate?.ExamSubject}</Td>
                <Td sx={DataStyle}>{format(new Date(eCandidate.DateReviewed), "dd/MM/yyyy")}</Td>
                {/* <Td sx={DataStyle}>{format(new Date(eCandidate.DateReviewed), "dd/MM/yyyy")}</Td> */}
              
              </ROWSTYLE>
              )}
            </Tbody>
          </Table>
        </TableContainer>
        :'Not Found'  
      }
      <StylePaginateBox>
        <ReactPaginate
          breakLabel="..."
          nextLabel=">"
          onPageChange={handlePageClick}
          pageRangeDisplayed={5}
          pageCount={pageCount}
          previousLabel="<"
          renderOnZeroPageCount={null}
        />

      </StylePaginateBox>
      </GridItem>
      
      <GridItem as={Flex} flexDir="column" gap="20px" mt="4" >
       
        <Flex justify="center" gap="30px" align="center">
          <Button  bg="var(--dark-green-color)" onClick={checked_ids && checked_ids.length > 0?()=>handleBatchPublish():()=>{}}
           color="var(--white-color)" width="130px"  >
            {publishIsLoading?'Loading':'Publish'}
          </Button>
        </Flex> 
      </GridItem>
    </Grid>
}
    </>
    
    
  )
    
  }
  const StylePaginateBox = styled.div`
  width:100%;
  & > ul{
    list-style-type: none;
    text-align:center;
    padding:0;
    margin:0;
    margin-top:10px;
  } 
  & > ul > li{
    display: inline;
    margin:0 5px;
    padding:2px 5px;
    border-radius: 3px;
    background-color: transparent;
    color:var(--dark-green-color);
  }
  & > ul > li.selected{
    background-color: var(--highlight-paginate-background);
    color:var(--highlight-paginate-color);
  }
  & > ul > li:first-of-type,
  & > ul > li:last-of-type{
    font-weight: bold;
  }
`